import React, { useEffect, useRef } from 'react';
import { EditorComponent } from '../../components/TiptapEditor/Editor';

export const LeftSide = ({ styles, blogData, changeSlug, changeTitle, changesTitles, handleBlur, handlePaste, errorMessage, setErrorMessage, editorContent, setEditorContent, handleContentChange, blogId }) => {
  const titleRef = useRef(null);

  useEffect(() => {
    if (titleRef.current && blogData?.title) {
      titleRef.current.innerText = blogData.title;
    }
  }, [blogData?.title]);

  return (
    <div className={styles.newpageLeft}>
      <div className={`${styles.newpageLeftRow} ${styles.textBlock} ${styles.editorBlock}`}>
        <div className={`${styles.newpageLeftRow}`}>
          <input
            type="hidden"
            placeholder="Write your title..."
            value={blogData?.title}
            onChange={(e) => { changeSlug(e.target.value); setErrorMessage({ ...errorMessage, title: '', slug: '' }) }}
          />
          <div
            ref={titleRef}
            id={styles.postTitle}
            placeholder="Write your title..."
            contentEditable="true"
            onKeyDown={(e) => {
              changeTitle(e);
              setErrorMessage({ ...errorMessage, title: '', slug: '' });
              if (e.target.innerText.trim().length > 0) {
                // setValidateTitle(false);
              }
            }}
            onBlur={(e) => {
              handleBlur(e);
              setErrorMessage({ ...errorMessage, title: '', slug: '' });
              if (e.target.innerHTML === "<br>") {
                e.target.innerHTML = "";
              }
            }}
            onKeyUp={(e) => {
              changesTitles(e);
              setErrorMessage({ ...errorMessage, title: '', slug: '' });
              if (e.target.innerText.trim().length > 0) {
                // setValidateTitle(false);
              }
              if (e.target.innerHTML === "<br>") {
                e.target.innerHTML = "";
              }
            }}
            onPaste={(e) => handlePaste(e)}
          ></div>
        </div>
        {errorMessage?.title && <p className='error-message'>{errorMessage?.title}</p>}
      </div>
      <EditorComponent setUpdatedContent={handleContentChange} editorContent={editorContent} id={blogId} setEditorContent={setEditorContent} />
      {errorMessage?.description && <p className='error-message' style={{paddingInline: 20}}>{errorMessage?.description}</p>}
    </div>
  );
};
  // }, [blogData?.title]);

  // return (
  //   <div className={styles.newpageLeft}>
  //     <div className={`${styles.newpageLeftRow} ${styles.textBlock} ${styles.editorBlock}`}>
  //       <div className={`${styles.newpageLeftRow}`}>
  //         <input
  //           type="hidden"
  //           placeholder="Write your title..."
  //           value={blogData?.title}
  //           onChange={(e) => { changeSlug(e.target.value); setErrorMessage({ ...errorMessage, title: '', slug: '' }) }}
  //         />
  //         <div
  //           ref={titleRef}
  //           id={styles.postTitle}
  //           placeholder="Write your title..."
  //           contentEditable="true"
  //           onKeyDown={(e) => {
  //             changeTitle(e);
  //             setErrorMessage({ ...errorMessage, title: '', slug: '' });
  //             if (e.target.innerText.trim().length > 0) {
  //               // setValidateTitle(false);
  //             }
  //           }}
  //           onBlur={(e) => {
  //             handleBlur(e);
  //             setErrorMessage({ ...errorMessage, title: '', slug: '' });
  //             if (e.target.innerHTML === "<br>") {
  //               e.target.innerHTML = "";
  //             }
  //           }}
  //           onKeyUp={(e) => {
  //             changesTitles(e);
  //             setErrorMessage({ ...errorMessage, title: '', slug: '' });
  //             if (e.target.innerText.trim().length > 0) {
  //               // setValidateTitle(false);
  //             }
  //             if (e.target.innerHTML === "<br>") {
  //               e.target.innerHTML = "";
  //             }
  //           }}
  //           onPaste={(e) => handlePaste(e)}
  //         ></div>
  //       </div>
  //       {errorMessage?.title && <p className='error-message'>{errorMessage?.title}</p>}
  //     </div>
  //   </div>
  // );
// };
